import { TemplateParamsPlugin } from "/srv/projects/www.cultus-dresden.de/site/node_modules/.pnpm/@unhead+vue@3.3.1_@oxc-project+types@0.143.0_esbuild@0.28.2_lightningcss@1.33.0_rolldow_77fb765a8e101f9050fb052b5187fe8f/node_modules/@unhead/vue/dist/plugins.mjs";
export default {
  disableDefaults: true,
  plugins: [TemplateParamsPlugin],
}